import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { taskItemFromActivity } from "@utils";
import { toast } from "@components/toast/Toast";
import NoteDetailModal from "@components/NoteDetailModal";
import { cancelScheduledAction } from "@api/actionsController";
import EventDetails from "../../calendar/displays/EventDetails";
import PlanDetailModal from "../../calendar/displays/PlanDetailModal";

// Activity rows open what they describe, in their own detail modals. Shared by the rail's Activity
// panel and the Today's tasks Activity tab so both open rows the same way.
export const useActivityDetail = () => {
  const queryClient = useQueryClient();
  const [planTarget, setPlanTarget] = useState(null);
  const [cancellingPlan, setCancellingPlan] = useState(false);
  const [taskTarget, setTaskTarget] = useState(null);
  const [noteTarget, setNoteTarget] = useState(null);

  const onSelect = (item) => {
    switch (item.opens) {
      case "plan":
        setPlanTarget({ actionId: item.actionId });
        break;
      case "task":
        setTaskTarget(taskItemFromActivity(item.activity));
        break;
      case "note":
        setNoteTarget(item.activity);
        break;
      default:
        break;
    }
  };

  const onCancelPlan = async (actionId) => {
    setCancellingPlan(true);
    try {
      await cancelScheduledAction(actionId);
      await queryClient.invalidateQueries({ queryKey: ["actionInstalments", actionId] });
      await queryClient.invalidateQueries({ queryKey: ["todaysTasks"] });
      setPlanTarget(null);
      toast({ description: "Scheduled work cancelled." });
    } catch {
      toast({ description: "Couldn't cancel this. Please try again." });
    } finally {
      setCancellingPlan(false);
    }
  };

  const modals = (
    <>
      {taskTarget && (
        <EventDetails
          item={taskTarget}
          isOpen={!!taskTarget}
          onClose={() => setTaskTarget(null)}
          readOnly
        />
      )}

      {noteTarget && (
        <NoteDetailModal
          activity={noteTarget}
          isOpen={!!noteTarget}
          onClose={() => setNoteTarget(null)}
        />
      )}

      {planTarget && (
        <PlanDetailModal
          actionId={planTarget.actionId}
          isOpen={!!planTarget}
          onClose={() => setPlanTarget(null)}
          onCancelAction={onCancelPlan}
          cancelling={cancellingPlan}
        />
      )}
    </>
  );

  return { onSelect, modals };
};
